import {
  IDLESTATUS_AWAY,
  IDLESTATUS_INACTIVE,
  IDLESTATUS_EXPIRED,
} from './constants';
import { logout } from '../../common/modules/auth';
import config from '../../../config';

export const idleStatusDelay = (idleStatus) => () => {
  if (idleStatus === IDLESTATUS_AWAY) return config.sessionAway;
  if (idleStatus === IDLESTATUS_INACTIVE) return config.sessionExpired;
  if (idleStatus === IDLESTATUS_EXPIRED) return 1000;
};

export const activeStatusAction = () => {};

export const idleStatusAction = (idleStatus) => (dispatch) => {
  switch (idleStatus) {
    case 'AWAY':
      break;
    case 'INACTIVE':
      break;
    case 'EXPIRED':
      dispatch(logout());
      break;
    default:
      break;
  }
};



// WEBPACK FOOTER //
// ./src/store/redux-idle-monitor/actions.js